import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ProfileModals = (props) => {
  const {
    showAddFamilyModal,
    handleCloseModal,
    message,
    newFamilyName,
    handleNewFamilyNameChange,
    submitAddFamily,
    showDeleteFamilyModal,
    submitDeleteFamily,
    showAddMemberModal,
    emailToAdd,
    handleEmailChange,
    submitAddMember,
    showDeleteMemberModal,
    membersOfSelectedFamily,
    handleMemberToDeleteChange,
    submitDeleteMember,
    showEditFamilyNameModal,
    submitEditFamilyName,
    showEditUserModal,
    handleCloseEditUserModal,
    editedUser,
    handleUserInputChange,
    submitEditUser,
  } = props;

  return (
    <>
      {/* Add Family Modal */}
      <Modal
        show={showAddFamilyModal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Family</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message && <p className="alert alert-info">{message}</p>}
          <Form.Group>
            <Form.Label>Family Name</Form.Label>
            <Form.Control
              type="text"
              value={newFamilyName}
              onChange={handleNewFamilyNameChange}
              placeholder="Enter family name"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={submitAddFamily}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Family Modal */}
      <Modal
        show={showDeleteFamilyModal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Family</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message && <p className="alert alert-info">{message}</p>}
          <p>Are you sure you want to delete this family?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={submitDeleteFamily}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Member Modal */}
      <Modal
        show={showAddMemberModal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message && <p>{message}</p>}
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={emailToAdd}
              onChange={handleEmailChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={submitAddMember}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Member Modal */}
      <Modal
        show={showDeleteMemberModal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message && <p>{message}</p>}
          {membersOfSelectedFamily && membersOfSelectedFamily.length > 1 ? (
            <Form.Group>
              <Form.Label>Select Member to Delete</Form.Label>
              <Form.Control
                as="select"
                onChange={handleMemberToDeleteChange}
              >
                <option value="">Select a member</option>
                {membersOfSelectedFamily.map((member) => (
                  <option key={member._id} value={member._id}>
                    {member.username}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          ) : (
            <p>
              This is the last member. Deleting this member will delete the
              entire family. Are you sure?
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="danger" onClick={submitDeleteMember}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Family Name Modal */}
      <Modal
        show={showEditFamilyNameModal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Family Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message && <p>{message}</p>}
          <Form.Group>
            <Form.Label>Family Name</Form.Label>
            <Form.Control
              type="text"
              value={newFamilyName}
              onChange={handleNewFamilyNameChange}
              placeholder="Enter new family name"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={submitEditFamilyName}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit User Modal */}
      <Modal
        show={showEditUserModal}
        onHide={handleCloseEditUserModal}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message && <p className="alert alert-info">{message}</p>}
          <Form.Group>
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={editedUser.username}
              onChange={handleUserInputChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={editedUser.email}
              onChange={handleUserInputChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEditUserModal}>
            Close
          </Button>
          <Button variant="primary" onClick={submitEditUser}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfileModals;
